import { secondsToTimeString } from '@/helpers/dateHelper';
import { strings } from '@/services/translation/strings';
import { FC } from 'react';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { twMerge } from 'tailwind-merge';
import { cellBase } from './calendarCellStyles';

interface ShiftsCellProps {
  shifts: { start: number; end: number; tasks?: { start: number; end: number }[] }[];
  locationName?: string;
}

const formatRange = (label: string, start: number, end: number) =>
  `${label}: ${secondsToTimeString(start)} - ${secondsToTimeString(end)}`;

export const MyCalendarShiftsCell: FC<ShiftsCellProps> = ({ shifts, locationName }) => (
  <div className="h-full flex flex-col space-y-1 py-2 justify-center items-center px-5">
    <div className="border-2 border-primary-500 p-1 text-primary-500 rounded-md w-full">
      <div className="flex items-center justify-center gap-1">
        <HiOutlineLocationMarker className="w-5 h-5" />
        <span className="text-sm font-semibold">{locationName}</span>
      </div>
    </div>

    {shifts.map((shift, index) => (
      <div key={index} className="flex flex-row items-stretch space-x-2 w-full">
        <div className={twMerge(cellBase, 'border-2 border-primary-500 text-primary-500 bg-primary-100')}>
          <div className="flex flex-row justify-between items-center px-5">
            <p className="font-semibold">{formatRange(strings.common.shift.toUpperCase(), shift.start, shift.end)}</p>

            {shift.tasks && shift.tasks.length > 0 && (
              <div className="bg-primary-500 text-white rounded-full w-8 h-8 text-xs flex items-center justify-center px-2">
                <p className="text-wrap text-center leading-tight">{shift.tasks.length}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    ))}
  </div>
);
